import { filter } from "lodash";


const initialState = {
    // POS REDUCER
    isAddingOrders: false,
    ordersList: [],
    isFetchingTodayOrdersData: false,
    todayOrdersDataList: [],
    searchTodayOrdersDataList: [],
    isSelect: "",

    // KDS REDUCER
    isGettingPendingOrder: false,
    PendingOrderList: [],
    SearchPendingOrderList: [],
};

const POSReducer = (state = initialState, action) => {
    switch (action.type) {

        // POS REDUCER
        case "REQUEST_ADD_ORDERS":
            return { ...state, isAddingOrders: true };
        case "SUCCESS_ADD_ORDERS":
            return { ...state, ordersList: action.payload, isAddingOrders: false };
        case "ERROR_ADD_ORDERS":
            return { ...state, isAddingOrders: false };


        case "REQUEST_GET_TODAY_ORDERS":
            return { ...state, isFetchingTodayOrdersData: true };
        case "SUCCESS_GET_TODAY_ORDERS":
            return {
                ...state,
                todayOrdersDataList: action.payload,
                searchTodayOrdersDataList: action.payload.data,
                isSelect: action.payload.data._id,
                isFetchingTodayOrdersData: false,
            };
        case "ERROR_GET_TODAY_ORDERS":
            return { ...state, isFetchingTodayOrdersData: false };








        // KDS REDUCER
        case "REQUEST_GET_PENDING_ORDER":
            return { ...state, isGettingPendingOrder: true };
        case "SUCCESS_GET_PENDING_ORDER":
            return { ...state, PendingOrderList: action.payload.data, SearchPendingOrderList: action.payload.data, isGettingPendingOrder: false, };
        case "ERROR_GET_PENDING_ORDER":
            return { ...state, isGettingPendingOrder: false };


        case "FILTER_ORDER":
            return {
                ...state,
                SearchPendingOrderList: action.payload == "" ? state.PendingOrderList : filter(state.PendingOrderList, x => x.number == action.payload)
            };
        case "FILTER_ORDER_BY_TABLE":
            return {
                ...state,
                SearchPendingOrderList: action.payload == "" ? state.PendingOrderList : filter(state.PendingOrderList, x => x.tableName == action.payload)
            };


        default:
            return state;
    }
};

export default POSReducer;